import { DEV_MCS_RUN_ENV, DEFAULT_MCS_RUN_ENV, DEFAULT_VERSION, McsRunEnvType } from './const.js';

function findMcsExecutionEnvironmentType(version, runEnv) {
    // INFO: По умолчанию на деве MCS_RUN_ENV - это номер ветки, значение DEV проставляется в frontend-builder,
    // но на всякий случай перестраховываемся и проверяем еще версию (локально она всегда DEFAULT_VERSION)
    if (!runEnv || ((runEnv === DEV_MCS_RUN_ENV || runEnv === DEFAULT_MCS_RUN_ENV) && version === DEFAULT_VERSION)) {
        return McsRunEnvType.Local;
    }
    if (runEnv.toLowerCase() === 'prod') {
        return McsRunEnvType.Prod;
    }
    return McsRunEnvType.Dev;
}

export { findMcsExecutionEnvironmentType };
//# sourceMappingURL=utils.js.map
